// import { ViewItemPopUpMiniCartEvent } from '@/components/GTM';
import Image from '@/components/image';
import DeleteCartItem from '@/components/ui/buttons/delete-cart-item';
import { FeeCard } from '@/components/ui/cards';
import { useTranslations } from 'next-intl';
import QtyControlBtns from '../QtyControlBtns';
import { priceFormatedObject, validatePrice } from '@/utils/category';
import { handlePriceByComma } from '@/helpers/common';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import NextLink from '@/components/next-link';

const CartPopUpItem = ({ info, togglePopup }) => {
  const t = useTranslations('cart');
  const price = validatePrice(priceFormatedObject(info));
  return (
    <div className='border-border flex flex-col gap-4 rounded-md border p-3 max-lg:p-2'>
      <div className='flex gap-4'>
        <NextLink
          href={`/product/${info?.rewrite_url || info?.url_key?.[0]}`}
          onClick={() => {
            togglePopup();
            // ViewItemPopUpMiniCartEvent(info);
          }}
          className='border-border flex h-20 w-17.5 items-center justify-center rounded-md border sm:h-25 sm:w-20 md:w-25 lg:size-32'
        >
          <Image
            loading='lazy'
            src={
              info?._media_?.image?.at(0)?.image ||
              (info?.extension_attributes?.product_image &&
                `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${info?.extension_attributes?.product_image}`)
            }
            className='size-10 object-contain md:size-20 lg:size-20'
            alt={info?.name}
          />
        </NextLink>
        <div className='flex flex-1 flex-col gap-1.5 lg:gap-3'>
          <div className='flex justify-between gap-4'>
            <NextLink
              href={`/product/${info?.rewrite_url || info?.url_key?.[0] || info?.extension_attributes?.url_key}`}
              onClick={() => {
                togglePopup();
                // ViewItemPopUpMiniCartEvent(info);
              }}
              className='line-clamp-2 text-xs sm:text-[13px] md:text-sm lg:text-base'
            >
              {info?.name || ''}
            </NextLink>
            <DeleteCartItem item_id={info?.item_id} />
          </div>
          <h5 className='text-[#605D5D] max-lg:text-xs max-sm:text-[13px]'>
            {info?.category?.[1]?.name ||
              info?.extension_attributes?.category_names?.[1]?.name}
          </h5>
          <div className='flex items-center justify-between sm:mt-2'>
            {/* <UpdateCartPopup info={info} /> */}
            <QtyControlBtns
              fromPopup={true}
              item_id={info?.item_id}
              quantity={info?.qty}
            />
            <div className='flex items-center gap-2 max-lg:gap-2'>
              <h5
                className={`flex items-center gap-1 text-neutral-400 line-through max-sm:text-[9px] sm:text-[13px] ${price?.final_price != price?.originalPrice ? 'visible' : 'invisible'}`}
              >
                {handlePriceByComma(price?.originalPrice)}{' '}
                <CurrencyIcon className='size-3 md:size-3.5' />
              </h5>
              <h3 className='flex items-center gap-1 text-xs font-bold sm:text-[13px] lg:text-lg'>
                {handlePriceByComma(price?.final_price || price?.originalPrice)}{' '}
                <CurrencyIcon className='size-3 md:size-3.5 lg:size-4' />
              </h3>
            </div>
          </div>
        </div>
      </div>
      {info?.productFeesFromCart?.length > 0 ? (
        <div className='grid grid-cols-3 gap-4 max-sm:grid-cols-1 max-sm:gap-2'>
          {info?.productFeesFromCart?.map((item, index) => (
            <FeeCard
              key={index}
              {...{
                index,
                info: item,
                item_id: info?.item_id,
                t,
                refetchCart: null,
              }}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default CartPopUpItem;
